import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Breadcrumbs, Link } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import {
    Box,
    Grid,
    Card,
    CardContent,
    Typography,
    Divider,
    Checkbox,
    FormControlLabel,
    Button,
    Chip,
    Stack
} from "@mui/material";

import {
    LocationOn,
    MailOutline,
    Verified,
    Business,
    ArrowForward
} from "@mui/icons-material";
import HeaderDashboard from "../../../components/HeaderDashboard";
import { useUser } from "../../../../contexts/UserContext";

export default function AssinarContratoEnderecoFiscal() {
    const navigate = useNavigate();
    const { user } = useUser();

    const [readContract, setReadContract] = useState(false);
    const [accepted, setAccepted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [conteudoContratoEnderecoFiscal, setConteudoContratoEnderecoFiscal] = useState('');
    const [dataAtualizacao, setDataAtualizacao] = useState('');

    useEffect(() => {
        if (user?.consentimentos?.idContratoEnderecoFiscal) {
            navigate("../dashboard/checkoutEnderecoFiscal");
        }
    }, [navigate])

    const handleScroll = (e) => {

        const element = e.target;

        if (
            element.scrollTop + element.clientHeight >=
            element.scrollHeight - 10
        ) {
            setReadContract(true);
        }

    };

    useEffect(() => {
        const getContratoEnderecoFiscal = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/get/contrato-endereco-fiscal`);
                console.log('Resposta do contrato endereco fiscal:', response.data);
                setConteudoContratoEnderecoFiscal(response.data.contrato.Conteudo);
                const data = new Date(response.data.contrato.DataCriacao);
                const dataFormatada = data.toLocaleDateString("pt-BR", {
                    day: "2-digit",
                    month: "long",
                    year: "numeric",
                    timeZone: "America/Sao_Paulo"
                });
                setDataAtualizacao(dataFormatada);
            } catch (error) {
                console.error('Erro ao buscar os termos de uso:', error);
            }
        };

        getContratoEnderecoFiscal();
    }, []);

    const handleConcordarContratoEnderecofiscal = async () => {
        if (accepted) {

            try {
                setLoading(true);
                const response = await axios.post(`${process.env.REACT_APP_API_URL}/concordarContratoEnderecoFiscal`, {}, {
                    headers: {
                        'Authorization': localStorage.getItem('token')
                    }
                });
                if (response.data.status === 200) {
                    navigate("../dashboard/checkoutEnderecoFiscal");
                }
            } catch (error) {
                console.error("Erro ao concordar com o contrato:", error);
            } finally {
                setLoading(false)
            }
        }
    }

    return (

        <>
            <HeaderDashboard />
            <div style={{ padding: "30px", background: "#f4f6f8", minHeight: "100vh", marginTop: "64px" }}>
                <div style={{ width: "100%", height: "fit-content", padding: "10px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "20px", marginBottom: "20px" }}>
                        <div style={{ width: "80%" }}>
                            <Breadcrumbs aria-label="breadcrumb">
                                <Link
                                    underline="hover"
                                    sx={{ display: 'flex', alignItems: 'center', cursor: "pointer" }}
                                    color="inherit"
                                    onClick={() => navigate("../dashboard")}
                                >
                                    <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                    Dashboard
                                </Link>
                                <Link
                                    underline="hover"
                                    sx={{ display: 'flex', alignItems: 'center', cursor: "pointer" }}
                                    color="inherit"
                                    onClick={() => navigate("../dashboard/apresentacaoEnderecoFiscal")}
                                >
                                    <AssignmentTurnedInIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                    Endereço Fiscal
                                </Link>
                                <Typography
                                    sx={{ color: 'text.primary', display: 'flex', alignItems: 'center' }}
                                >
                                    <AssignmentTurnedInIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                    Assinatura do Contrato
                                </Typography>
                            </Breadcrumbs>
                        </div>
                    </div>
                </div>

                <Box
                    sx={{
                        width: "fit-content",
                        mx: "auto",
                        mb: 5,
                    }}
                >

                    <Typography
                        variant="h4"
                        fontWeight={700}
                    >
                        Revisão da Contratação
                    </Typography>

                    <Typography
                        color="text.secondary"
                        mt={1}
                        mb={4}
                    >
                        Confira as informações abaixo antes de prosseguir com a assinatura.
                    </Typography>

                    <Chip
                        label="Etapa 2 de 3"
                        color="success"
                        sx={{ mb: 4 }}
                    />

                    <Grid container spacing={4}>

                        {/* ESQUERDA */}

                        <Grid item xs={12} md={8}>

                            {/* ENDEREÇO */}

                            <Card
                                sx={{
                                    borderRadius: 4,
                                    mb: 3
                                }}
                            >

                                <CardContent>

                                    <Stack
                                        direction="row"
                                        spacing={2}
                                        alignItems="center"
                                    >

                                        <LocationOn color="success" />

                                        <Typography
                                            variant="h6"
                                            fontWeight={700}
                                        >
                                            Endereço Fiscal
                                        </Typography>

                                    </Stack>

                                    <Divider sx={{ my: 2 }} />

                                    <Typography fontWeight={600}>
                                        ContBlack Business Center
                                    </Typography>

                                    <Typography color="text.secondary">
                                        {user?.enderecoFiscal?.rua || "..."} , {user?.enderecoFiscal?.numero || "..."} - {user?.enderecoFiscal?.bairro || "..."}
                                    </Typography>

                                    <Typography color="text.secondary">
                                        {user?.enderecoFiscal?.cidade || "..."} • {user?.enderecoFiscal?.estado || "..."}
                                    </Typography>

                                    <Typography color="text.secondary">
                                        CEP {user?.enderecoFiscal?.cep || "..."}
                                    </Typography>

                                </CardContent>

                            </Card>

                            {/* BENEFÍCIOS */}

                            <Grid container spacing={2}>

                                <Grid item xs={12} md={4}>

                                    <Card sx={{ borderRadius: 4 }}>

                                        <CardContent>

                                            <MailOutline color="success" />

                                            <Typography
                                                fontWeight={700}
                                                mt={2}
                                            >
                                                Correspondências
                                            </Typography>

                                            <Typography
                                                variant="body2"
                                                color="text.secondary"
                                            >
                                                Recebimento e aviso das notificações.
                                            </Typography>

                                        </CardContent>

                                    </Card>

                                </Grid>

                                <Grid item xs={12} md={4}>

                                    <Card sx={{ borderRadius: 4 }}>

                                        <CardContent>

                                            <Verified color="success" />

                                            <Typography
                                                fontWeight={700}
                                                mt={2}
                                            >
                                                Registro
                                            </Typography>

                                            <Typography
                                                variant="body2"
                                                color="text.secondary"
                                            >
                                                Aceito para abertura e alteração de empresa.
                                            </Typography>

                                        </CardContent>

                                    </Card>

                                </Grid>

                                <Grid item xs={12} md={4}>

                                    <Card sx={{ borderRadius: 4 }}>

                                        <CardContent>

                                            <Business color="success" />

                                            <Typography
                                                fontWeight={700}
                                                mt={2}
                                            >
                                                Gestão
                                            </Typography>

                                            <Typography
                                                variant="body2"
                                                color="text.secondary"
                                            >
                                                Administração completa feita pela ContBlack.
                                            </Typography>

                                        </CardContent>

                                    </Card>

                                </Grid>

                            </Grid>

                            {/* CONTRATO */}

                            <Card
                                sx={{
                                    borderRadius: 4,
                                    mt: 3,
                                    maxWidth: 950
                                }}
                            >

                                <CardContent>

                                    <Typography
                                        variant="h6"
                                        fontWeight={700}
                                        mb={2}
                                    >
                                        Contrato de Prestação de Serviço
                                    </Typography>

                                    <Divider />

                                    <Box
                                        onScroll={handleScroll}
                                        sx={{
                                            mt: 3,
                                            height: 500,
                                            overflow: "auto",
                                            border: "1px solid #ddd",
                                            borderRadius: 2,
                                            p: 2
                                        }}
                                    >

                                        {false ?

                                            <iframe
                                                title="Contrato"
                                                src={"#"}
                                                style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    border: "none"
                                                }}
                                            />
                                            :
                                            <div dangerouslySetInnerHTML={{ __html: conteudoContratoEnderecoFiscal }} />
                                        }

                                    </Box>

                                    <FormControlLabel
                                        sx={{
                                            mt: 3,
                                            alignItems: "flex-start",
                                            "& .MuiFormControlLabel-label": {
                                                fontSize: "14px",
                                                lineHeight: 1.5,
                                                color: "#374151",
                                            },
                                        }}
                                        control={
                                            <Checkbox
                                                disabled={!readContract}
                                                checked={accepted}
                                                onChange={(e) => setAccepted(e.target.checked)}
                                                sx={{
                                                    mt: -1.3,
                                                    color: "#9C01B9",

                                                    "&.Mui-checked": {
                                                        color: "#9C01B9",
                                                    },

                                                    "&:hover": {
                                                        backgroundColor: "rgba(156, 1, 185, 0.08)",
                                                    },

                                                    "&.Mui-focusVisible": {
                                                        outline: "2px solid rgba(156, 1, 185, 0.25)",
                                                        outlineOffset: "2px",
                                                    },

                                                    "&.Mui-disabled": {
                                                        color: "#D1D5DB",
                                                    },
                                                }}
                                            />
                                        }
                                        label={
                                            readContract
                                                ? "Li e concordo com todas as cláusulas do contrato."
                                                : "Leia o contrato até o final para habilitar esta opção."
                                        }
                                    />

                                </CardContent>

                            </Card>

                        </Grid>

                        {/* DIREITA */}

                        <Grid item xs={12} md={4}>

                            <Box
                                sx={{
                                    position: "sticky",
                                    top: 110
                                }}
                            >

                                <Card
                                    sx={{
                                        borderRadius: 4
                                    }}
                                >

                                    <CardContent>

                                        <Typography
                                            variant="h6"
                                            fontWeight={700}
                                        >
                                            Resumo da Contratação
                                        </Typography>

                                        <Divider sx={{ my: 2 }} />

                                        <Stack spacing={2}>

                                            <Box>

                                                <Typography
                                                    variant="body2"
                                                    color="text.secondary"
                                                >
                                                    Serviço
                                                </Typography>

                                                <Typography fontWeight={600}>
                                                    Endereço Fiscal
                                                </Typography>

                                            </Box>

                                            <Box>

                                                <Typography
                                                    variant="body2"
                                                    color="text.secondary"
                                                >
                                                    Valor
                                                </Typography>

                                                <Typography
                                                    variant="h4"
                                                    fontWeight={700}
                                                    color="success.main"
                                                >
                                                    R${user?.enderecoFiscal?.valor.toFixed(2).replace(".", ",") || "..."}
                                                </Typography>

                                                <Typography color="text.secondary">
                                                    por mês
                                                </Typography>

                                            </Box>

                                            <Divider />

                                            <Typography>

                                                ✔ Privacidade do endereço

                                            </Typography>

                                            <Typography>

                                                ✔ Recebimento de correspondências

                                            </Typography>

                                            <Typography>

                                                ✔ Gestão completa

                                            </Typography>

                                            <Typography>

                                                ✔ Contrato digital

                                            </Typography>

                                            <Divider />

                                            <Button
                                                fullWidth
                                                size="large"
                                                variant="contained"
                                                endIcon={<ArrowForward />}
                                                disabled={!accepted || loading}
                                                onClick={handleConcordarContratoEnderecofiscal}
                                                sx={{
                                                    mt: 2,
                                                    minHeight: 54,
                                                    px: 3,
                                                    borderRadius: "12px",

                                                    backgroundColor: "#9C01B9",
                                                    color: "#fff",

                                                    fontSize: "15px",
                                                    fontWeight: 700,
                                                    textTransform: "none",

                                                    boxShadow: "0 6px 18px rgba(156, 1, 185, 0.25)",

                                                    transition: "all 0.25s ease",

                                                    "&:hover": {
                                                        backgroundColor: "#85009E",
                                                        boxShadow: "0 8px 24px rgba(156, 1, 185, 0.35)",
                                                        transform: "translateY(-1px)",
                                                    },

                                                    "&:active": {
                                                        transform: "translateY(0)",
                                                    },

                                                    "&:disabled": {
                                                        backgroundColor: "#E5E7EB",
                                                        color: "#9CA3AF",
                                                        boxShadow: "none",
                                                    },

                                                    "& .MuiButton-endIcon": {
                                                        marginLeft: "8px",
                                                        transition: "transform 0.25s ease",
                                                    },

                                                    "&:hover .MuiButton-endIcon": {
                                                        transform: "translateX(4px)",
                                                    },
                                                }}
                                            >
                                                {loading ? "Processando..." : "Concordar e Prosseguir"}
                                            </Button>
                                        </Stack>
                                    </CardContent>
                                </Card>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </div>

        </>

    );

}